<template>
    <div class="h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">Other Species Data Entry</h2>
            <p class="tw-italic tw-text-gray-700">
                Select a collection code and add non-Anopheline data
            </p>
        </b-container>

        <b-container fluid>
            <b-row>
                <b-col></b-col>
                <b-col cols="auto">
                    <b-form-datepicker
                        id="start_date"
                        v-model="formData.start_date"
                        placeholder="Start Date"
                        class="mb-2"
                        size="lg"
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col cols="auto" v-if="formData.start_date">
                    <b-form-datepicker
                        id="end_date"
                        :min="formData.start_date"
                        v-model="formData.end_date"
                        placeholder="End Date"
                        class="mb-2"
                        size="lg"
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col cols="auto">
                    <b-button
                        @click="filter()"
                        variant="success"
                        class="px-5"
                        size="lg"
                        :disabled="!formData.end_date"
                    >
                        Search by Range
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
        <hr />

        <b-container fluid>
            <b-row>
                <b-col class="tw-p-1">
                    <b-tabs
                        v-model="tabIndex"
                        content-class="mt-4"
                        justified
                        lazy
                    >
                        <b-tab title="SpeciesID">
                            <template v-slot:title>
                                <h4>SpeciesID</h4>
                            </template>

                            <EntoDataHOT
                                :collectionCode="collectionCode"
                                :collectionCodeStatus="collectionCodeStatus"
                                :start-date="startDate"
                                :end-date="endDate"
                                templateId="pcr"
                            />
                        </b-tab>
                        <!-- <b-tab title="ELISA Result">
                            <template v-slot:title>
                                <h4>ELISA Result</h4>
                            </template>

                            <EntoDataHOT
                                :collectionCode="collectionCode"
                                :collectionCodeStatus="collectionCodeStatus"
                                :start-date="startDate"
                                :end-date="endDate"
                                templateId="kdr"
                            />
                        </b-tab> -->
                    </b-tabs>
                </b-col>
            </b-row>
        </b-container>

    </div>
</template>

<script>

import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import EntoDataHOT from "@/components/unitaid/ento-data/EntoDataHOT.vue";

import { mapActions } from "vuex";
import * as _ from "lodash";

// import { HTTP } from "@/utilities/http-common";

export default {
    components: {
        EntoDataHOT,
    },
    mixins: [DashboardBaseTemplate],
    data: function () {
        return {
            keyword: "",
            collectionCode: "",
            collectionCodeStatus: "draft",
            collectionCodes: [],
            selectedCollectionCode: {},
            tabIndex: 0,
            formData: {},
            startDate: '',
            endDate: ''
        };
    },
    mounted() {
        const that = this;

        // If an index is given, activate it.
        this.tabIndex = this.$route.query.tabIndex
            ? parseInt(this.$route.query.tabIndex)
            : 0;

        that.getEntoCollectionCodes()
            .then((response) => {
                _.each(response.data, function (item) {
                    // if (item.status !== "draft") {
                    //     that.collectionCodes.push(item);
                    // }
                    that.collectionCodes.push(item);
                });

                this.keyword = this.$route.query.collectionCode
                    ? this.$route.query.collectionCode
                    : "";
                this.search();
            })
            .catch((error) => {
                HandleErrors.HandleErrors(error);
            });
    },
    methods: {
        ...mapActions("websheet", ["getEntoCollectionCodes"]),
        search: function () {
            const that = this;
            that.selectedCollectionCode = _.find(that.collectionCodes, [
                "collection_code",
                that.keyword,
            ]);
            that.collectionCodeStatus = that.selectedCollectionCode.status;
            that.collectionCode = that.keyword;
        },
        filter: function () {
            const that = this;
            that.endDate = '';
            that.collectionCode = '';
            
            // Trick to only search on endDate change.
            setTimeout(() => {
                that.startDate = that.formData.start_date;
                that.endDate = that.formData.end_date;
            }, 1000);
        },
    },
    beforeRouteUpdate(to, from, next) {
        // Since we are re-using the view, when it is updated, set the current tab to the 'to' route tabIndex or set it to
        // zero.
        this.tabIndex = to.query.tabIndex ? to.query.tabIndex : 0;
        next();
    },
};
</script>

<style>
@import "~handsontable/dist/handsontable.full.css";

.ht {
    width: 100%;
}
.nav-tabs .nav-link {
    font-weight: 500;
    color: #999;
}
</style>
